import React, { useState, useMemo } from "react";
import Stack from "react-bootstrap/Stack";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCirclePlus,
  faArrowRotateRight,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons";
import Spinner from "react-bootstrap/Spinner";
import { useCookies } from "react-cookie";

// components
import { getSingleTransferPdfApi } from "../../../context/api/reports/transfer-reports/getSingleTransferPdfApi";
import { deleteTransferSetData } from "../../../context/api/delete/transfer/deleteTransferSetData";
import ConfirmModal from "../../dynamic-components/ConfirmModal";
import Message from "../../utils/modals/Message";
import DataTable from "../../dynamic-components/DataTable";
import SearchBar from "../../dynamic-components/SearchBar";
import CreateTransferModal from "../../utils/modals/transfer-modal/create-transfer/CreateTransferModal";
import UpdateTransferModal from "../../utils/modals/transfer-modal/update-transfer/UpdateTransferModal";
import WithdrawTransferModal from "../../utils/modals/transfer-modal/withdraw-transfer/WithdrawTransferModal";

const TransfersTable = ({
  lang,
  tableData,
  loader,
  setRefreshData,
  getAllCustomers,
  btnLoader,
  getCustomersLoader,
  allCustomers,
  getPdf,
}) => {
  const dataTranslate = require(`../../../translate/${
    lang === "AR" ? "arabic" : "english"
  }/data.json`);

  const searchByData =
    dataTranslate.pages.transfers_p.table.table_head.search_by;

  const initialAddModal = {
    isShow: false,
  };

  const initialUpdateModal = {
    isShow: false,
    rowData: {},
  };

  const initialWithdrawModal = {
    isShow: false,
    rowData: {},
  };

  const initialConfirmModal = {
    isShow: false,
    rowData: {},
  };

  const initialSinglePdfModal = {
    isShow: false,
    rowData: {},
  };

  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const initialSuccessMessage = {
    success: false,
    type: "",
    data: {},
  };

  const action = {
    title: dataTranslate.popups.create_transfer.delete_transfer,
    submit: dataTranslate.popups.create_transfer.delete,
  };

  const singlePdfAction = {
    title: dataTranslate.popups.create_transfer.getSinglepdf_title,
    submit: dataTranslate.popups.create_transfer.getSinglepdf,
  };

  const [cookies] = useCookies();
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [successMessage, setSuccessMessage] = useState(initialSuccessMessage);
  const [confirmBtnLoader, setConfirmBtnLoader] = useState(false);
  const [confirmModal, setConfirmModal] = useState(initialConfirmModal);
  const [singlePdfLoader, setSinglePdfLoader] = useState(false);
  const [singlePdfModal, setSinglePdfModal] = useState(initialSinglePdfModal);
  const [showAddModal, setShowAddModal] = useState(initialAddModal);
  const [showUpdateModal, setShowUpdateModal] = useState(initialUpdateModal);
  const [showWithdrawModal, setShowWithdrawModal] =
    useState(initialUpdateModal);

  const [search, setSearch] = useState({
    type: "processing_id",
    value: "",
  });

  const handleSearch = (e) => {
    const value = e.target.value || undefined;
    setSearch((prev) => ({ ...prev, value: value }));
  };
  const searchOptions = [{ key: "processing_id", value: searchByData.processing_id }];

  const columns = useMemo(
    () => [
      // {
      //   Header: dataTranslate.pages.transfers_p.table.table_body.transfer_id,
      //   accessor: "id",
      // },
      {
        Header: dataTranslate.pages.transfers_p.table.table_body.processing_id,
        accessor: "processing_id",
      },
      {
        Header: dataTranslate.pages.transfers_p.table.table_body.fullName,
        accessor: "fullName",
      },
      {
        Header:
          dataTranslate.pages.transfers_p.table.table_body.transfer_amount,
        // accessor: "amount",
        Cell: ({ cell }) => {
          return (
            <div className="d-flex flex-row align-items-center gap-2">
              <div>{cell.row.original.amount}</div>
              <div>{cell.row.original.currency}</div>
            </div>
          );
        },
      },
      {
        Header: dataTranslate.pages.transfers_p.table.table_body.total_amount,
        accessor: "totalAmount",
      },
      {
        Header: dataTranslate.pages.transfers_p.table.table_body.transfer_fee,
        accessor: "fees",
      },
      {
        Header: dataTranslate.pages.transfers_p.table.table_body.fees_rates,
        Cell: ({ cell }) => {
          return (
            <div className="d-flex flex-row align-items-center gap-2">
              <div>{cell.row.original.feesRates}</div>
              <div>%</div>
            </div>
          );
        },
      },
      {
        Header: dataTranslate.pages.transfers_p.table.table_body.createdAt_date,
        accessor: "creation_date",
        Cell: ({ cell }) => {
          return <div>{cell.row.original.creation_date.split("T")[0]}</div>;
        },
      },
      {
        Header: dataTranslate.pages.transfers_p.table.table_body.status,
        accessor: "status",
      },
      {
        Header: dataTranslate.pages.transfers_p.table.table_body.notes,
        accessor: "NB",
        Cell: ({ cell }) => {
          return cell.row.original.NB ? (
            <span>{cell.row.original.NB || dataTranslate.addotional.null}</span>
          ) : (
            <span>{dataTranslate.addotional.null}</span>
          );
        },
      },
      {
        Header: dataTranslate.pages.transfers_p.table.table_body.action,
        Cell: ({ cell }) => {
          if (cell.row.original.status === "غير مسحوبة") {
            return (
              <div className="d-flex gap-3">
                <button
                  className="transfers_p-table-table-body-btn"
                  onClick={() => {
                    setShowUpdateModal((prev) => ({
                      ...prev,
                      isShow: true,
                      rowData: cell.row.original,
                    }));
                  }}
                >
                  {dataTranslate.pages.transfers_p.table.table_body.edit}
                </button>
                <button
                  className="transfers_p-table-table-body-btn"
                  onClick={() =>
                    setShowWithdrawModal((prev) => ({
                      ...prev,
                      isShow: true,
                      rowData: cell.row.original,
                    }))
                  }
                >
                  {dataTranslate.pages.transfers_p.table.table_body.withdraw}
                </button>
                <button
                  className="transfers_p-table-table-body-btn-report"
                  onClick={() => {
                    setSinglePdfModal((prev) => ({
                      ...prev,
                      isShow: true,
                      rowData: cell.row.original,
                    }));
                  }}
                >
                  {dataTranslate.pages.transfers_p.table.table_body.report}
                </button>
                <button
                  className="transfers_p-table-table-body-btn-delete"
                  onClick={() =>
                    setConfirmModal((prev) => ({
                      ...prev,
                      isShow: true,
                      rowData: cell.row.original,
                    }))
                  }
                >
                  {dataTranslate.pages.transfers_p.table.table_body.delete}
                </button>
              </div>
            );
          } else {
            return <div></div>;
          }
        },
      },
    ],
    []
  );

  const deleteTransfer = async (id) => {
    const transferId = id;
    setConfirmBtnLoader(() => true);
    await deleteTransferSetData(
      lang,
      setMessageResponse,
      cookies,
      transferId,
      setSuccessMessage
    );
    setConfirmBtnLoader(() => false);
  };

  const getSinglePdf = async (id) => {
    setSinglePdfLoader(() => true);
    const transferId = id;
    await getSingleTransferPdfApi(
      cookies,
      setMessageResponse,
      setSinglePdfLoader,
      transferId
    );
  };
  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />
      <div className="transfers_p-table w-100 d-flex flex-column align-items-center">
        <div className="transfers_p-table-nav w-100 m-3 px-3">
          <Stack direction="horizontal" gap={3}>
            <div
              className="transfers_p-table-nav-btn"
              onClick={async () => {
                await getAllCustomers();
                setShowAddModal((prev) => ({
                  ...prev,
                  isShow: true,
                }));
              }}
            >
              {getCustomersLoader ? (
                <Spinner animation="border" variant="warning" />
              ) : (
                <>
                  <span>
                    {dataTranslate.pages.transfers_p.table.table_head.add}
                  </span>
                  <FontAwesomeIcon
                    icon={faCirclePlus}
                    size="xl"
                    style={{ color: "#f2ce00" }}
                  />
                </>
              )}
            </div>

            <div className="transfers_p-table-nav-btn" onClick={() => getPdf()}>
              {btnLoader ? (
                <Spinner animation="border" variant="warning" />
              ) : (
                <span>
                  {dataTranslate.pages.transfers_p.table.table_head.report}
                </span>
              )}
              <FontAwesomeIcon
                icon={faFileContract}
                size="xl"
                style={{ color: "#f2ce00" }}
              />
            </div>

            <div
              className={
                lang === "AR"
                  ? "ms-auto transfers_p-table-nav-btn"
                  : "me-auto transfers_p-table-nav-btn"
              }
              onClick={() => {
                setRefreshData((prev) => prev + 1);
              }}
            >
              <span>
                {dataTranslate.pages.transfers_p.table.table_head.refresh}
              </span>
              <FontAwesomeIcon
                icon={faArrowRotateRight}
                size="xl"
                style={{ color: "#f2ce00" }}
              />
            </div>

            <SearchBar
              lang={lang}
              search={search}
              handleSearch={handleSearch}
              options={searchOptions}
              setSearch={setSearch}
            />
          </Stack>
        </div>

        <div className="transfers_p-table-table w-100 m-3 px-3">
          <CreateTransferModal
            show={showAddModal.isShow}
            onHide={() => setShowAddModal(initialAddModal)}
            lang={lang}
            dataTranslate={dataTranslate}
            setRefreshData={setRefreshData}
            allCustomers={allCustomers}
          />

          <UpdateTransferModal
            show={showUpdateModal.isShow}
            onHide={() => setShowUpdateModal(initialUpdateModal)}
            lang={lang}
            dataTranslate={dataTranslate}
            data={showUpdateModal.rowData}
            setRefreshData={setRefreshData}
          />

          <WithdrawTransferModal
            show={showWithdrawModal.isShow}
            onHide={() => setShowWithdrawModal(initialWithdrawModal)}
            lang={lang}
            dataTranslate={dataTranslate}
            data={showWithdrawModal.rowData}
            setRefreshData={setRefreshData}
          />

          <ConfirmModal
            show={confirmModal.isShow}
            onHide={() => setConfirmModal(initialConfirmModal)}
            post={deleteTransfer}
            data={confirmModal.rowData}
            lang={lang}
            dataTranslate={dataTranslate}
            setRefreshData={setRefreshData}
            action={action}
            btnLoader={confirmBtnLoader}
            successMessage={successMessage}
            setSuccessMessage={setSuccessMessage}
          />

          <ConfirmModal
            show={singlePdfModal.isShow}
            onHide={() => setSinglePdfModal(initialSinglePdfModal)}
            post={getSinglePdf}
            data={singlePdfModal.rowData}
            lang={lang}
            dataTranslate={dataTranslate}
            setRefreshData={setRefreshData}
            action={singlePdfAction}
            btnLoader={singlePdfLoader}
            successMessage={successMessage}
            setSuccessMessage={setSuccessMessage}
          />

          {tableData ? (
            <DataTable
              lang={lang}
              columns={columns}
              dataTable={tableData}
              pageClass="transfers_p"
              loader={loader}
              search={search}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default TransfersTable;
